import { useContext } from "react"
import { IChannelsContext } from "../contexts/models/IChannelsContext"
import { ChannelsContext } from "../contexts/ChannelsContext"

export const useChannelsService = () => {
    return useContext<IChannelsContext>(ChannelsContext);
}